import React from 'react';
import { FaPlus, FaMinus, FaTrash, FaTimes, FaSpinner } from 'react-icons/fa';
import { useKitchenCart } from '../context/KitchenCartContext';
import './CartModal.css';

const KitchenCartModal = ({ isOpen, onClose, onCheckout, isLoading }) => {
  const { cartItems, totalPrice, removeFromCart, updateQuantity, clearCart } = useKitchenCart();

  // Format price (kitchen items use standard currency, not cents)
  const formatPrice = (price) => {
    return price.toLocaleString('en-US', {
      style: 'currency',
      currency: 'KES'
    });
  };

  if (!isOpen) return null;

  return (
    <div className="cart-modal-overlay">
      <div className="cart-modal">
        <div className="cart-modal-header">
          <h2>Your Cart - Kitchen & Bar</h2>
          <button className="close-modal" onClick={onClose}>
            <FaTimes />
          </button>
        </div>

        {cartItems.length === 0 ? (
          <div className="empty-cart">
            <p>Your cart is empty</p>
          </div>
        ) : (
          <>
            <div className="cart-modal-items">
              {cartItems.map(item => {
                const imageUrl = item.image_url || '/assets/images/default.jpg';
                
                return (
                  <div className="cart-modal-item" key={item.uuid}>
                    <div className="cart-item-image">
                      <img src={imageUrl} alt={item.name} onError={(e) => {
                        e.target.onerror = null;
                        e.target.src = '/assets/images/default.jpg';
                      }} />
                    </div>
                    <div className="cart-item-details">
                      <h3>{item.name}</h3>
                      <p>{formatPrice(item.price)} each</p>
                    </div>
                    <div className="cart-item-actions">
                      <div className="quantity-controls">
                        <button 
                          onClick={() => updateQuantity(item.uuid, item.quantity - 1)}
                          aria-label="Decrease quantity"
                          disabled={isLoading}
                        >
                          <FaMinus />
                        </button>
                        <span>{item.quantity}</span>
                        <button 
                          onClick={() => updateQuantity(item.uuid, item.quantity + 1)}
                          aria-label="Increase quantity"
                          disabled={isLoading}
                        >
                          <FaPlus />
                        </button>
                      </div>
                      <button 
                        className="remove-item" 
                        onClick={() => removeFromCart(item.uuid)}
                        aria-label="Remove item"
                        disabled={isLoading}
                      >
                        <FaTrash />
                      </button>
                    </div>
                    <div className="cart-item-total">
                      {formatPrice(item.price * item.quantity)}
                    </div>
                  </div>
                );
              })}
            </div>
            
            <div className="cart-modal-summary">
              <div className="cart-total">
                <span>Total:</span>
                <span>{formatPrice(totalPrice)}</span>
              </div>
              <div className="cart-modal-actions">
                <button 
                  className="continue-shopping" 
                  onClick={onClose}
                  disabled={isLoading}
                >
                  Continue Shopping
                </button>
                <button 
                  className="checkout-btn" 
                  onClick={onCheckout}
                  disabled={isLoading || cartItems.length === 0}
                >
                  {isLoading ? (
                    <>
                      <FaSpinner className="spinner" />
                      Processing...
                    </>
                  ) : (
                    'Proceed to Checkout'
                  )}
                </button>
                <button 
                  className="clear-cart" 
                  onClick={clearCart}
                  disabled={isLoading}
                >
                  Clear Cart
                </button>
              </div>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default KitchenCartModal;
